import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { PARAM_VALUE } from "../constants";
import { BuilderExtension } from "../BuilderExtension";
/**
 * Конвертирует чистое значение в объект с ключом { value }, для последующего расширения
 */
export var ValueExtension = /*#__PURE__*/function (_BuilderExtension) {
  _inherits(ValueExtension, _BuilderExtension);
  var _super = _createSuper(ValueExtension);
  function ValueExtension(ValueClass) {
    var _this;
    _classCallCheck(this, ValueExtension);
    _this = _super.call(this);
    _this.ValueClass = ValueClass;
    return _this;
  }
  _createClass(ValueExtension, [{
    key: "serialize",
    value: function serialize(cls) {
      var value = cls.serialize();
      return typeof value !== 'undefined' ? _defineProperty({}, PARAM_VALUE, value) : undefined;
    }
  }, {
    key: "create",
    value: function create() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 ? arguments[1] : undefined;
      return new this.ValueClass(data[PARAM_VALUE], params);
    }
  }, {
    key: "createProjection",
    value: function createProjection() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _params = arguments.length > 1 ? arguments[1] : undefined;
      return {
        evaluate: function evaluate() {
          return data[PARAM_VALUE];
        }
      };
    }
  }]);
  return ValueExtension;
}(BuilderExtension);